"use client";

import { BotpressChat } from "@/components/botpress/botpress-chat";
import { usePathname } from "next/navigation";

/**
 * Global chatbot that appears on specific pages based on route patterns
 */
export function GlobalChatbot() {
	const pathname = usePathname();

	// Don't show chatbot on SUP or project pages (they have CTA bar integration)
	// Don't show on contact page (they have big button)
	// Don't show on preference page (will be in more menu)
	// const isSearchPage = pathname?.match(/^\/(bengaluru|bangalore|[^\/]+)/);
	const isSUPOrProjectPage = pathname?.match(/^(\/[^\/]+)?\/(units|projects)\/[^\/]+/);
	const isContactPage = pathname === "/contact";
	const isPreferencePage = pathname === "/preference";

	// Show FAB on all other pages
	// In development, show it even on SUP/Project pages
	const isDev = process.env.NODE_ENV === "development";
	const shouldShowFAB = isDev && (isContactPage || isPreferencePage || isSUPOrProjectPage);

	if (!shouldShowFAB) {
		return null;
	}

	return <BotpressChat mode="fab" />;
}
